import React, { useState } from "react";
import { useEffect } from "react";
import {
  Box,
  ErrorAndSuccess,
  FlexBox,
  ListBox,
} from "../../../../../Components/Boxes/index";
import { useResponsive } from "../../../../../Components/Hooks";
import Icon from "../../../../../Components/Icons";
import { Button } from "../../../../../Components/Input/index";
import FormDialog from "../../../../../Components/Modals/FormDialog";
import { Text } from "../../../../../Components/Text";
import useMedicineDispathers from "../../../../../redux/dispatchers/useMedicineDispatchers";
import {
  useAllMedicineGetStatusSelector,
  useAllMedicineSelector,
  useMedicineGetErrorMessageSelector,
  useMoreMedicineItemsLeftInPaginationSelector,
} from "../../../../../redux/selectors/useMedicinesSelectors";
import { formateDateToReadableFormatWithoutTime } from "../../../../../utiles/dateformate";
import MuiSkeletonLoader from "../../../../../Components/LoadingSkeleton/MuiSkeletonLoader";
import * as asyncStates from "../../../../../redux/constants/asyncStates";
import EmptyState from "../../../../../Components/NoRecordFound";
import Tabs from "../../../../../Components/Input/Tabs";
import EditMedicine from "../Dialogs/Medicine/EditMedicine"
import usePermissionsController from "../../../../../permissions";
import { REPETITION_END_DATE_TYPE } from "../../../../../constants";

const Medicine = ({ clientId }) => {
  // ---see whether it's desktop size or not-----
  const isDesktop = useResponsive({ xs: false, sm: true });
  const {
    accessArchives
  } = usePermissionsController()

  //------------ dispatchers ---------------------
  const { getAllMedicine, clearAllLocalMedicine } = useMedicineDispathers();

  // ----------- selectors -------------------------
  const gettingAllMedicine = useAllMedicineSelector();
  const gettingAllMedicineStatus = useAllMedicineGetStatusSelector();
  const medicineGetErrorMessage = useMedicineGetErrorMessageSelector();
  const errorMessage = medicineGetErrorMessage;
  const moreMedicineItemsLeftInPagination = useMoreMedicineItemsLeftInPaginationSelector()

  // ----------- states ---------------------------
  const [medicineToEdit, setMedicineToEdit] = useState(null);
  const [isArchived, setIsArchived] = useState(false)
  const [open, setOpen] = useState(false);
  function HandleDialog() {
    setOpen(!open);
    setMedicineToEdit(null);
  }

  const loadMore = () => {
    getAllMedicine({
      clientId: clientId,
      startAfter: gettingAllMedicine[gettingAllMedicine.length - 1].id,
      isArchived: isArchived,
    });
  }

  useEffect(() => {
    clearAllLocalMedicine();
    getAllMedicine({
      isArchived: isArchived,
      clientId: clientId,
    });
  }, [isArchived]);
  return (
    <Box
      $width="100%"
      $backgroundColor="#fff"
    >
      <FlexBox $justifyContent={accessArchives ? "space-between" : "flex-end"} $width="100%" $marginTop={2}>
        {accessArchives && <Tabs
          $onChanged={(val) => {
            if (val == 0) {
              setIsArchived(false)
            } else {
              setIsArchived(true)
            }
          }}
          $value={isArchived ? 1 : 0}
          $tabs={[
            { name: "Active" },
            { name: "Archived" },
          ]}
          $width={"fit-content"}
        />}

        <Button
          $onClick={() => {
            HandleDialog();
          }}
        >
          <Icon $icon="Add" $color="white"></Icon>
          <Text $color={"white"}>New Medicine</Text>
        </Button>
      </FlexBox>

      <FlexBox $width="100%" $marginTop={3} $padding="3">
        <Box $width="30%">
          <Text $fontWeight="bold">
            Name
          </Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>Morning</Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>Noon</Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>Afternoon</Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>Evening</Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>Night</Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>Start Date</Text>
        </Box>
        <Box $width="17%" $display="flex" $justifyContent="center">
          <Text>End Date</Text>
        </Box>
      </FlexBox>

      {gettingAllMedicineStatus === asyncStates.SUCCESS &&
        gettingAllMedicine < 1 ? (
        <FlexBox $marginTop={7} $width="100%" $justifyContent="center">
          <EmptyState />
        </FlexBox>
      ) : (
        gettingAllMedicine?.map((value, index) => {
          return (
            <ListBox
              $width="100%"
              key={index}
              $index={index}
              $onClick={() => {
                HandleDialog();
                setMedicineToEdit(value);
              }}
            >
              <FlexBox $width="100%" >
                <Box $width="30%">
                  <Text $fontWeight="bold">
                    {value.medicine.name}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.dosage.morning}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.dosage.noon}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.dosage.afternoon}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.dosage.evening}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.dosage.night}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.startDate && formateDateToReadableFormatWithoutTime(value.startDate)}
                  </Text>
                </Box>
                <Box $width="17%" $display="flex" $justifyContent="center">
                  <Text $fontWeight="bold">
                    {value.endDate && value.repetitionEndDateType != REPETITION_END_DATE_TYPE.NEVER ? formateDateToReadableFormatWithoutTime(value.endDate) : "Never"}
                  </Text>
                </Box>
              </FlexBox>
            </ListBox>
          );
        })
      )}
      {gettingAllMedicineStatus === asyncStates.PENDING &&
        [1, 2, 3].map((value) => {
          return (
            <Box $width="100%" $marginTop="2" key={value}>
              <MuiSkeletonLoader
                $variant="rectangular"
                $width={"100%"}
                $height={40}
              />
            </Box>
          );
        })}

      {errorMessage && (
        <FlexBox $marginTop={2} $width="100%">
          <ErrorAndSuccess $type="error">{errorMessage}</ErrorAndSuccess>
        </FlexBox>
      )}

      {moreMedicineItemsLeftInPagination && <FlexBox $marginTop="6" $width="100%" $justifyContent="center">
        <Button $onClick={() => {
          loadMore()
        }} >Load More</Button>
      </FlexBox>}

      <FormDialog
        $open={open}
        $handleDialog={HandleDialog}
        $title={"Medicine"}
        $maxWidth="sm"
        $fullWidth
        $fullScreen={!isDesktop}
      >
        <EditMedicine
          $handleDialog={HandleDialog}
          $type={"add"}
          $medicine={medicineToEdit}
          clientId={clientId}
        />
      </FormDialog>
    </Box>
  );
};

export default Medicine;
